import { useParams } from 'react-router-dom';
import { IChainInfo } from '@kattana-io/common';
import ChainAbout from '../../../components/SEO/mobile/About';
import Modal from '../../../components/Modal';
import ChainPairsTable from './ChainPairsTable';
import { getChainStatistics } from '../helpers';

interface ITokenProps {
  chain: IChainInfo;
  slug: string;
  title: string;
  logo: string;
}

const ChainMobile = ({ chain, slug, title, logo }: ITokenProps) => {
  const params = useParams();

  return (
    <div className='mobile_seo_page'>
      <div className='mobile_seo_page__content'>
        <ChainAbout
          title={title}
          subTitle={slug}
          slug={slug}
          description={`${title} is a highly scalable blockchain platform for DeFi, crypto dApps, and enterprise applications.`}
          logo={logo}
          statisticsTitle={`${params.chain} Chain Statistics`}
          statistics={getChainStatistics(chain.chain)}
        />
        <ChainPairsTable pairs={Object.values(chain.pairs)} />
      </div>
      <Modal />
    </div>
  );
};

export default ChainMobile;
